var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeftBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "E421_x2C__Back_x2C__buttons_x2C__multimedia_x2C__play_x2C__stop"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "white"
    },
    cx: 256,
    cy: 256,
    r: 230
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E81CE"
    },
    d: "M256,496c-64.108,0-124.378-24.964-169.707-70.293C40.964,380.379,16,320.108,16,256 S40.964,131.622,86.293,86.293C131.622,40.964,191.892,16,256,16s124.379,24.964,169.707,70.293 C471.036,131.622,496,191.892,496,256s-24.964,124.379-70.293,169.707C380.379,471.036,320.108,496,256,496z M256,36 C134.691,36,36,134.691,36,256s98.691,220,220,220s220-98.691,220-220S377.309,36,256,36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E81CE"
    },
    d: "M346,266H176c-5.523,0-10-4.478-10-10c0-5.523,4.477-10,10-10h170c5.522,0,10,4.477,10,10 C356,261.522,351.522,266,346,266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E81CE"
    },
    d: "M226,316c-2.559,0-5.119-0.977-7.071-2.929l-50-50c-3.905-3.905-3.905-10.237,0-14.143l50-50 c3.905-3.905,10.237-3.905,14.143,0c3.905,3.905,3.905,10.237,0,14.143L190.142,256l42.929,42.929 c3.905,3.905,3.905,10.237,0,14.143C231.119,315.023,228.559,316,226,316z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftBlue);
export default __webpack_public_path__ + "static/media/arrow-left-blue.136ebec7f5bde3fe99b3d17ddd2e259e.svg";
export { ForwardRef as ReactComponent };